import { PencilSquareIcon } from '@heroicons/react/24/outline';
import { Link, LinkProps } from 'react-router-dom';

type EditIconLinkProps = LinkProps & {
  label?: string;
};

export function EditIconLink({ label = 'Editar', className = '', ...props }: EditIconLinkProps) {
  return (
    <Link
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-secondary-500 transition-colors hover:bg-primary-50 hover:text-primary-600 ${className}`}
      {...props}
    >
      <PencilSquareIcon className="h-5 w-5" />
    </Link>
  );
}
